module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "member_placeholder.e67afaa2.png";